export default {
    "0010": "darkcyan",
    "0260": "orange",
    "T900": "#cc1424",
    "T903": "#cc1424",
};